import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.borderGrey,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 50
  const h = 50
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_528_46937)">
        <path
          d="M26.25 29.5L21.75 25L26.25 20.5"
          stroke="#101010"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="1"
          y="1"
          width="48"
          height="48"
          rx="24"
          stroke="#101010"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_528_46937"
          x="-10"
          y="-10"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_528_46937"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_528_46937"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgComponent
